module.exports = __webpack_public_path__ + "02_very_short_black.85ecc785.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_very_short_black.png
// module id = OFnT
// module chunks = 0